import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RegisterAccountInfo } from '../../models/account';
import { AccountService } from '../../services/account.service';
import { Router, ActivatedRoute } from '@angular/router';
import { WindowService } from '../../services/window.service';
import { Store } from '@ngrx/store';
import * as fromStore from '../../store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { PackageList, urlPath } from '../../shareModel';
import * as fromMyfeatures from '../../my-features';

@Component({
  standalone: false,
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit, OnDestroy {
  displayInfoDialog = false;
  logoPath: any;
  hostName: string;
  private componentDestroyed = new Subject();
  RegisterAccountInfo: RegisterAccountInfo = {
    Account: '',
    Password: '',
    FirstName: '',
    LastName: '',
    Occupation: '',
    Country: '',
    IsMarketingMail: true,
    RegisterSys: 1,
    RegisterType: 1,
    CompanyId: 1
  };
  PasswordConfirm: string;
  AgreePrivacyPolicy: any[];
  shareModel = {
    PackageList: PackageList,
    urlPath: urlPath
  };
  inputType = 'password';
  showPasswordIcon: Boolean = false;
  inputTypeConfirm = 'password';
  showPasswordIconConfirm: Boolean = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private apiService: AccountService,
    private windowService: WindowService,
    private store: Store<fromStore.State>,
    private messageService: MessageService
  ) {
    this.store.dispatch(new fromMyfeatures.GetRegions());
    this.hostName = this.windowService.getHostName();
    this.store.select(fromStore.getRegions).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.length > 0) {
        const region = this.windowService.getLogoRegion(res);
        if (typeof region !== 'undefined' && region !== null) {
          this.RegisterAccountInfo.CompanyId = region.Id;
          this.logoPath = region.Note;
        }
        // const company = res.find(i => i.Region.toLowerCase() === this.hostName);
        // const companyId = (company) ? company.Id : null;
        // if (!!companyId) {
        //   this.RegisterAccountInfo.CompanyId = companyId;
        // }
        // const logo = res.find(i => i.Region.toLowerCase() === this.hostName.toLowerCase());
        // const logoPath = (logo) ? logo.Note : null;
        // if (!!logoPath) {
        //   this.logoPath = logoPath;
        // }
      }
    });
  }

  CountryOptions = [
    { label: 'Select Country', value: null }
  ];

  ngOnInit() {
    this.ngxService.start();
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-login');
    body.classList.remove('body-landing');
    body.classList.remove('mobile-toggle');
    this.apiService.ReadCountryList().subscribe(res => {
      if (res !== null) {
        const opt = res.map(function (e) {
          return { label: e, value: e };
        });
        this.CountryOptions = this.CountryOptions.concat(opt);
      }
    });
    this.AgreePrivacyPolicy = [];
    this.ngxService.stop();
  }

  registerAccount(e) {
    this.ngxService.start();
    if (e.valid && e.value.Country && e.value.Password === e.value.PasswordConfirm && this.AgreePrivacyPolicy.length) {
      this.apiService.RegisterAccount(this.RegisterAccountInfo).subscribe(res => {
        if (res.Flag) {
          this.displayInfoDialog = true;
          // this.router.navigate(['/login']);
        } else {
          this.messageService.add({ severity: 'error', summary: res.Message });
        }
      });
    }
    this.ngxService.stop();
  }

  closeDialog() {
    this.displayInfoDialog = false;
    this.router.navigate(['/login']);
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  handleChange(e: any) {
    const isChecked = e.checked;
    if (isChecked) {
      this.inputType = 'text';
    } else {
      this.inputType = 'password';
    }
  }

  handleConfirmChange(e: any) {
    const isChecked = e.checked;
    if (isChecked) {
      this.inputTypeConfirm = 'text';
    } else {
      this.inputTypeConfirm = 'password';
    }
  }

  passwordChange(password: string) {
    if (password.length  > 0) {
      this.showPasswordIcon = true;
    } else if (password.length  === 0) {
      this.showPasswordIcon = false;
      this.inputType = 'password';
    }
  }

  passwordConfirmChange(passwordConfirm: string) {
    if (passwordConfirm.length  > 0) {
      this.showPasswordIconConfirm = true;
    } else if (passwordConfirm.length  === 0) {
      this.showPasswordIconConfirm = false;
      this.inputTypeConfirm = 'password';
    }
  }

}
